const ENScience = [
    {
        title: 'South Africa slashes science budget, funds for giant radio telescope',
        description: 'South Africa, struggling to contain economic fallout from the COVID-19 pandemic, has cut $20 million from its budget for the Square Kilometre Array (SKA). The cut was part of a 24 June budget announcement in which the country, anticipating severely reduced revenues and an increased need for health and social spending, slashed its science budget for the year by 16%.',
        url: 'https://www.sciencemag.org/news/2020/06/south-africa-slashes-science-budget-funds-giant-radio-telescope',
        image: 'https://www.sciencemag.org/sites/default/files/styles/article_main_image_-_1280w__no_aspect_/public/Meerkat_1000p.jpg?itok=RIuUHS-q',
        publishedAt: "2020-06-25T15:20:00Z",
        source: {
            name: 'Science Mag',
            url: 'https://www.sciencemag.org'
        }
    },
    {
        title: 'Canada’s Museums of Science and Innovation will reopen this summer',
        description: 'Ingenium—Canada’s Museums of Science and Innovation has announced plans to reopen the Canada Agriculture and Food Museum, the Canada Aviation and Space Museum and the Canada Science and Technology Museum will reopen this summer.',
        url: 'https://ottawa.ctvnews.ca/canada-s-museums-of-science-and-innovation-will-reopen-this-summer-1.5018695',
        image: 'https://www.ctvnews.ca/polopoly_fs/1.3680042.1510790816!/httpImage/image.jpg_gen/derivatives/landscape_1020/image.jpg',
        publishedAt: "2020-06-25T18:50:00Z",
        source: {
            name: 'CTV News',
            url: 'https://ottawa.ctvnews.ca'
        }
    },
    {
        title: 'Is it time to replace one of the cornerstones of animal research?',
        description: 'As millions of animals continue to be used in biomedical research each year, and new legislation calls on federal agencies to reduce and justify their animal use, some have begun to argue that it’s time to replace the three Rs themselves.',
        url: 'https://www.sciencemag.org/news/2020/06/it-time-replace-one-cornerstones-animal-research',
        image: 'https://www.sciencemag.org/sites/default/files/styles/article_main_image_-_1280w__no_aspect_/public/mouse_1280p_1.jpg?itok=uBDLgJYl',
        publishedAt: "2020-06-27T11:40:00Z",
        source: {
            name: 'Science Mag',
            url: 'https://www.sciencemag.org'
        }
    },
    {
        title: 'Here’s how flying snakes stay aloft',
        description: 'Scientists captured the undulating motion of paradise tree snakes gliding from tree to tree.',
        url: 'https://www.sciencenews.org/article/how-flying-snakes-stay-aloft',
        image: 'https://www.sciencenews.org/wp-content/uploads/2020/06/062620_ec_flyingsnake_feat-1028x579.jpg',
        publishedAt: "2020-06-28T10:20:00Z",
        source: {
            name: 'Science News',
            url: 'https://www.sciencenews.org'
        }
    },
    {
        title: '‘It’s a nightmare.’ How Brazilian scientists became ensnared in chloroquine politics',
        description: 'Now that several big trials have shown disappointing results, hope has faded that chloroquine or hydroxychloroquine might be miracle drugs against COVID-19. But for one group of researchers in Brazil, the story is far from over.',
        url: 'https://www.sciencemag.org/news/2020/06/it-s-nightmare-how-brazilian-scientists-became-ensnared-chloroquine-politics',
        image: 'https://www.sciencemag.org/sites/default/files/styles/article_main_image_-_1280w__no_aspect_/public/gravedigger_MAIN_1280p.jpg?itok=WO-ICkJv',
        publishedAt: "2020-06-27T17:30:00Z",
        source: {
            name: 'Science Mag',
            url: 'https://www.sciencemag.org'
        }
    },
    {
        title: 'Working up a sweat may one day power up a device',
        description: 'A new supercapacitor collects perspiration to power a sensor.',
        url: 'https://www.sciencenewsforstudents.org/article/working-up-a-sweat-may-one-day-power-up-a-device',
        image: 'https://www.sciencenewsforstudents.org/wp-content/uploads/2020/06/1030_sweat_powered_electronics-1030x579.jpg',
        publishedAt: "2020-06-21T12:50:00Z",
        source: {
            name: 'Science News for Students',
            url: 'https://www.sciencenewsforstudents.org'
        }
    },
    {
        title: 'Why scientists say wearing masks shouldn’t be controversial',
        description: 'Cloth face coverings help curb the spread of the coronavirus, studies suggest.',
        url: 'https://www.sciencenews.org/article/covid-19-coronavirus-why-wearing-masks-controversial',
        image: 'https://www.sciencenews.org/wp-content/uploads/2020/06/062320_ti_masks_feat-1028x579.jpg',
        publishedAt: "2020-06-20T09:30:00Z",
        source: {
            name: 'Science News',
            url: 'https://www.sciencenews.org'
        }
    },
    {
        title: 'Strokes and mental state changes hint at how COVID-19 harms the brain',
        description: 'New clues emerge about relatively rare, but potentially severe, neurological symptoms.',
        url: 'https://www.sciencenews.org/article/coronavirus-covid-19-brain-strokes-mental-state-changes',
        image: 'https://www.sciencenews.org/wp-content/uploads/2020/06/062520_ls_covid-brains_feat-1028x579.jpg',
        publishedAt: "2020-06-25T15:50:00Z",
        source: {
            name: 'Science News',
            url: 'https://www.sciencenews.org'
        }
    },
    {
        title: 'Colliding black holes may have created a surprising flare of light',
        description: 'Researchers expect only gravitational waves to be spawned in these sorts of smashups.',
        url: 'https://www.sciencenews.org/article/colliding-black-holes-may-have-created-surprising-flare-light',
        image: 'https://www.sciencenews.org/wp-content/uploads/2020/06/062420_EC_black-hole-light_feat-1028x579.jpg',
        publishedAt: "2020-06-22T17:40:00Z",
        source: {
            name: 'Science News',
            url: 'https://www.sciencenews.org'
        }
    },
    {
        title: 'New Website Maps and Models the Science of Peace',
        description: 'A recent United Nations report claimed, “If there is a principal raison d’être for the creation of the United Nations, it is to sustain international peace in all its dimensions.”',
        url: 'https://blogs.ei.columbia.edu/2020/06/29/sustaining-peace-project-website/',
        image: 'https://blogs.ei.columbia.edu/wp-content/uploads/2020/06/Screen-Shot-2020-06-29-at-9.25.09-AM-637x359.png',
        publishedAt: "2020-06-26T17:10:00Z",
        source: {
            name: 'State of the Planet',
            url: 'https://blogs.ei.columbia.edu'
        }
    },
    {
        title: 'What a controversial face mask study says about science in the Covid-19 era',
        description: 'A Nobel Prize winner coauthored a study in a major journal. More than 40 researchers want it retracted.',
        url: 'https://www.vox.com/2020/6/29/21302489/coronavirus-face-mask-covid-19-pnas-study',
        image: 'https://cdn.vox-cdn.com/thumbor/q18MwK8hvFqWlX1m4rV83FmfvMs=/0x0:5256x3504/920x613/filters:focal(2306x920:3146x1760):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/66996947/GettyImages_1252565162.0.jpg',
        publishedAt: "2020-06-27T13:30:00Z",
        source: {
            name: 'Vox',
            url: 'https://www.vox.com'
        }
    },
    {
        title: 'Sloppy race science or sensationalist journalism?',
        description: 'UCT Professor Nicoli Nattrass responds to a two-part commentary on her research by Daily Maverick’s Ferial Haffajee.',
        url: 'https://www.dailymaverick.co.za/article/2020-06-29-sloppy-race-science-or-sensationalist-journalism/',
        image: 'https://www.dailymaverick.co.za/wp-content/uploads/Reply-Nattrass-HaffajeeTW-1536x768.jpg',
        publishedAt: "2020-06-24T12:40:00Z",
        source: {
            name: 'Daily Maverick',
            url: 'https://www.dailymaverick.co.za'
        }
    },
    {
        title: 'LED light from a £12 torch ‘significantly improves vision’ for the over 40s',
        description: 'Participants shone the torch into their eyes for three minutes a day for two weeks and found their ability to detect colours and see in low light had improved.',
        url: 'https://www.sciencefocus.com/news/led-light-from-a-12-torch-significantly-improves-vision-for-the-over-40s/',
        image: 'https://images.immediate.co.uk/production/volatile/sites/4/2020/06/featureimage-10bcecb.jpg?webp=true&quality=90&resize=620%2C423',
        publishedAt: "2020-06-22T12:30:00Z",
        source: {
            name: 'Science Focus',
            url: 'https://www.sciencefocus.com'
        }
    },
    {
        title: 'ECHO Science Spotlight: Try this fun experiment about Bernoulli’s Principle!',
        description: 'If a bird is in a tree and decides to go explore somewhere else, it takes off and elegantly flies away. However, if we did the same thing we wouldn’t fly. We would fall straight to the ground!',
        url: 'https://eu.burlingtonfreepress.com/story/news/2020/06/29/what-bernoullis-principle-try-echo-science-spotlight-activity-home-vermont/3262879001/',
        image: 'https://www.gannett-cdn.com/presto/2020/06/26/PBUR/5342e742-867f-4fd4-b13b-1714cffe7b98-2020_0625_SS-bernouilli.jpg?width=1080&quality=50',
        publishedAt: "2020-06-22T19:10:00Z",
        source: {
            name: 'Burlington Free Press',
            url: 'https://eu.burlingtonfreepress.com'
        }
    },
    {
        title: 'Dr. Eugenie Clark Dove Deep Into Science and Founded Mote Marine Laboratory',
        description: 'Sarasota’s world-famous “Shark Lady” spent much of her life underwater, also writing and teaching about fascinating sea life.',
        url: 'https://www.sarasotamagazine.com/news-and-profiles/2020/06/more-stories-of-influential-women-in-sarasota-history-marking-the-passage-of-women-s-right-to-vote',
        image: 'https://res.cloudinary.com/sagacity/image/upload/c_crop,h_1000,w_1500,x_0,y_0/c_limit,dpr_auto,f_auto,fl_lossy,q_80,w_1080/Eugenie_Clark_bck34k.jpg',
        publishedAt: "2020-06-27T14:30:00Z",
        source: {
            name: 'Saracota Magazine',
            url: 'https://www.sarasotamagazine.com'
        }
    },
    {
        title: 'Sudbury teen recognized for science project to help people people with depression, anxiety',
        description: 'Nethra Wickramasinghe is one of five winners from across Canada of the Weston Youth Innovation Award.',
        url: 'https://www.cbc.ca/news/canada/sudbury/sudbury-science-award-nethra-wickramasinghe-1.5630641',
        image: 'https://i.cbc.ca/1.5630692.1593380450!/fileImage/httpImage/image.JPG_gen/derivatives/16x9_780/nethra-wickramasinghe.JPG',
        publishedAt: "2020-06-24T17:30:00Z",
        source: {
            name: 'CBC',
            url: 'https://www.cbc.ca'
        }
    },
    {
        title: 'Could a global ‘observatory’ of blood help stop the next pandemic?',
        description: 'Michael Mina is out for blood—millions of samples, which a nascent effort dubbed the Global Immunological Observatory (GIO), would monitor for signs of pathogens spreading through the population. Instead of a telescope, it will rely on technology that can measure hundreds of thousands of distinct antibodies in a microliter of blood.',
        url: 'https://www.sciencemag.org/news/2020/06/could-global-observatory-blood-help-stop-next-pandemic',
        image: 'https://www.sciencemag.org/sites/default/files/styles/article_main_image_-_1280w__no_aspect_/public/blood_1280p.jpg?itok=F3EQUy-5',
        publishedAt: "2020-06-27T10:50:00Z",
        source: {
            name: 'Science Mag',
            url: 'https://www.sciencemag.org'
        }
    },
    {
        title: 'Researchers around the world prepare to #ShutDownSTEM and ‘Strike For Black Lives’',
        description: 'Thousands of researchers around the world have pledged to pause their work on Wednesday to support the ongoing Black Lives Matter movement and efforts against racism in the scientific community and society at large.',
        url: 'https://www.sciencemag.org/news/2020/06/researchers-around-world-prepare-shutdownstem-and-strike-black-lives',
        image: 'https://www.sciencemag.org/sites/default/files/styles/article_main_image_-_1280w__no_aspect_/public/ShutDownAcademia_1280p_update.jpg?itok=uA4Vlp8I',
        publishedAt: "2020-06-27T17:20:00Z",
        source: {
            name: 'Science Mag',
            url: 'https://www.sciencemag.org'
        }
    },
    {
        title: 'Mysterious radiation spike detected over Scandinavia',
        description: 'It may have come from a nuclear power plant in Russia.',
        url: 'https://www.livescience.com/spike-in-radioactivity-detected-above-europe.html',
        image: 'https://cdn.mos.cms.futurecdn.net/zVeYvpAvUsddpQLUqAYbS9-650-80.jpg',
        publishedAt: "2020-06-17T13:30:00Z",
        source: {
            name: 'Live Science',
            url: 'https://www.livescience.com'
        }
    },
    {
        title: 'Baby planets are born exceptionally fast, study suggests',
        description: 'Planets are forming around young stars far faster than scientists expected, arising in a cosmic eye blink of less than half a million years, according to a new study. That finding could inform models of planet formation and help resolve a problem plaguing astronomers since 2018, when data indicated that planetary nurseries contained far too little material to actually create planets.',
        url: 'https://www.sciencemag.org/news/2020/06/missing-mass-planet-formation-found-young-disks-gas-and-dust',
        image: 'https://www.sciencemag.org/sites/default/files/styles/article_main_image_-_1280w__no_aspect_/public/protoplanet_1280p.jpg?itok=iK9QsI8H',
        publishedAt: "2020-06-28T18:40:00Z",
        source: {
            name: 'Science Mag',
            url: 'https://www.sciencemag.org'
        }
    }
]

export default ENScience;